/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from 'react';
// @mui
import { Stack, Typography, Box, Container, Grid, Card, CardHeader, IconButton, Button } from '@mui/material';
import { Helmet } from 'react-helmet-async';
// components
import { useSelector, useDispatch } from 'react-redux';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import MultiSelector from '../multi-selector/multiSelector';
import VideoPlayer from '../video-player/videoPlayer';
import { appSliceActions } from '../../appSlices/appSlice';
import axiosInstance from '../../utils/axiosInstance';

export default function LiveStreamTest() {
  const sensorList = useSelector((state) => state.app.sensorList);
  const testStatus = useSelector((state) => state.app.recordedTestFailed);
  const [selectedSensorList, setSelectedSensorList] = useState([]);
  const [sensorInRow, setSensorInRow] = useState(2);
  const [iteration, setIteration] = useState(0);
  const [startTest, setStartTest] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const notiRef = useRef(true);
  const reasons = useRef([]);
  const testInterval = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    if (testStatus.status) {
      if (testInterval.current == null) {
        console.log('test has already stopped');
        dispatch(appSliceActions.setRecordedTestFailed({ status: false, reason: '' }));
        return;
      }
      const jsonData = {
        fallback: 'Auto test live stream',
        text: 'Auto test live stream',
        pretext: 'Live Stream',
        color: '#FF0000',
        fields: [
          {
            title: 'Iteration',
            value: iteration,
            short: false,
          },
          {
            title: 'Host',
            value: window.location.host,
            short: false,
          },
          {
            title: 'Reason',
            value: testStatus.reason,
            short: false,
          },
        ],
      };
      setEndDate(new Date());
      if (notiRef.current && testStatus.reason.includes('live')) {
        reasons.current.push(testStatus.reason);
        notiRef.current = false;
        axiosInstance
          .post(
            `null`,
            JSON.stringify(jsonData)
          )
          .then((response) => {
            console.log('slack noti', response.data);
          })
          .catch((e) => {
            console.error('slack noti error', e);
          });
        setTimeout(() => {
          notiRef.current = true;
        }, 5000);
      }
      handleStopTest();
      dispatch(appSliceActions.setRecordedTestFailed({ status: false, reason: '' }));
    }
  }, [testStatus, dispatch]);

  useEffect(() => {
    window.recordedStreamingSensors = selectedSensorList;
    return () => {
      window.recordedStreamingSensors = null;
      clearInterval(testInterval.current);
      testInterval.current = null;
    };
  }, [selectedSensorList]);

  useEffect(() => {
    setSelectedSensorList([]);
  }, [sensorList]);

  const handleInputValue = (val) => {
    setInputValue(val);
  };
  const handleSelectedSensorListChange = (val) => {
    setSelectedSensorList(val);
  };

  const handleZoomOut = () => {
    setSensorInRow((prev) => (prev < 3 ? prev + 1 : prev));
  };

  const handleZoomIn = () => {
    setSensorInRow((prev) => (prev > 1 ? prev - 1 : prev));
  };

  const closeSensor = (sensor) => {
    const temp = selectedSensorList.filter((item) => item.sensorId !== sensor.sensorId);
    setSelectedSensorList(temp);
  };

  const handleStartTest = () => {
    reasons.current = [];
    setStartTest(true);
    setIteration(1);
    setEndDate(null);
    setStartDate(new Date());
    testInterval.current = setInterval(() => {
      setStartTest(false);
      setTimeout(() => {
        if (!(testStatus.status || testInterval.current == null)) {
          setIteration((prev) => prev + 1);
          setStartTest(true);
        }
      }, 500);
    }, 40000);
  };

  const handleStopTest = () => {
    setStartTest(false);
    clearInterval(testInterval.current);
    testInterval.current = null;
  };

  return (
    <div>
      <Helmet>
        <title> stream </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Live stream test
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <Box sx={{ p: 3 }}>
                <Typography>{`Iteration: ${iteration}`}</Typography>
                <Typography>{`Approx runtime: ${iteration * 40} seconds`}</Typography>
                {startDate != null && <Typography>{`Start date-time: ${startDate.toLocaleString()}`}</Typography>}
                {endDate != null && <Typography>{`End date-time: ${endDate.toLocaleString()}`}</Typography>}
                {reasons.current.map((el, index) => (
                  <Typography key={index}>{`Reason: ${el}`}</Typography>
                ))}
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Card>
              <CardHeader title={'Live streams'} subheader={'Stream live streams'} />
              <Box sx={{ p: 3 }}>
                <Stack spacing={3} sx={{ mb: 2 }}>
                  <MultiSelector
                    id="recorded-stream-selector-multi"
                    placeholder="Type to search"
                    label="Select sensors"
                    value={selectedSensorList}
                    inputValue={inputValue}
                    onInputChange={handleInputValue}
                    onChange={handleSelectedSensorListChange}
                    getOptionLabel={(option) => {
                      if (option.remoteDeviceName && option.remoteDeviceLocation) {
                        return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
                      } if (option.remoteDeviceName) {
                        return `${option.name} at ${option.remoteDeviceName}`;
                      }
                      return option.name;

                    }}
                    options={sensorList}
                    disabled={startTest}
                  />
                </Stack>
                <Box
                  m={1}
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="flex-end"
                  sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'flex' } }}
                >
                  <IconButton onClick={handleZoomIn}>
                    <ZoomInIcon />
                  </IconButton>
                  <IconButton onClick={handleZoomOut}>
                    <ZoomOutIcon />
                  </IconButton>
                </Box>
              </Box>
              <Box m={2} display="flex" justifyContent="flex-end" alignItems="flex-end">
                <Button variant="contained" onClick={handleStartTest} sx={{ mr: 1 }}>
                  Start
                </Button>
                <Button variant="contained" onClick={handleStopTest}>
                  Stop
                </Button>
              </Box>
            </Card>
          </Grid>
          {startTest &&
            selectedSensorList.map((sensor) => (
              <Grid item xs={12} sm={12} md={12 / sensorInRow} key={sensor.sensorId}>
                <VideoPlayer sensor={sensor} sensorInRow={sensorInRow} page="live" closeSensor={closeSensor} liveTest />
              </Grid>
            ))}
        </Grid>
      </Container>
    </div>
  );
}
